import React, { useEffect, useState } from 'react'
import icBrodccast from '../../assets/svg/broadcasts/card-icon/card.svg'
import icPreview from '../../assets/svg/broadcasts/ic-pagination/preview.svg'
import icNext from '../../assets/svg/broadcasts/ic-pagination/next.svg'
import icBtnVeiw from '../../assets/svg/btn/eye.svg'
import btnCheck from '../../assets/svg/btn/icCheck.svg'
import btnEdit from '../../assets/svg/btn/edit-outline.svg'
import icDownload from '../../assets/svg/btn/download.svg'
import icArrowDown from '../../assets/svg/btn/ic-arrow-down.svg'
import icArrowRight from '../../assets/svg/btn/ic-arrow-right.svg'
import icViewsCounter from '../../assets/svg/btn/ic-view-bg-white.svg'
import axiosClient from '../../../axios-client'
import { Helmet } from 'react-helmet'

const AllConfirmations = () => {

    const [confirmations, setConfirmations] = useState([]);
    const [loading, setLoading] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState();
    const [hasData, setHasData] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [expandedRow, setExpandedRow] = useState(null);
    const [messagesUnpaidCount, setMessagesUnpaidCount] = useState(null);
    const [ messagesUnpaidCredit, setMessagesMnpaidCredit ] = useState(null);
    const [ metTitle, setMetaTitle ] = useState('');
    const [ metaDescription, setMetaDescription ] = useState('');

    useEffect(() => {
        getConfirmations();
        appSettings();
    }, [ currentPage ]);
    
    const appSettings = () => {
      axiosClient.get('/app-settings')
        .then(({ data }) => {
            setMetaTitle(data.data.title)
            setMetaDescription(data.data.description);
        })
        .catch(() => {
            setLoading(false)
        })
    }

    const getConfirmations = async () => {
        setLoading(true);
        try {
            const response = await axiosClient.get(`/confirmations?page=${currentPage}`);
            const { data } = response.data;
            // console.log(data)
            setConfirmations(data.paid_messages.confirmations)
            const { unpaid } = data.unpaid_messages.messages_unpaid_count
            if (unpaid > 0) {
                setMessagesUnpaidCount(data.unpaid_messages.messages_unpaid_count)
            }
            const { unpaidMsg } = data.unpaid_messages.messages_unpaid_credit;
            if (unpaidMsg > 0) {
                setMessagesMnpaidCredit(data.unpaid_messages.messages_unpaid_credit)
            }

            setTotalPages(data.paid_messages.pagination.total_pages);
            setLoading(false);
            setHasData(true)
        } catch (error) {
            console.error('Error fetching confirmations:', error);
            setLoading(false);
        }
    };

    // const totalRecords = confirmations.length;

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const filteredData = confirmations.filter((item) => {
        return (
            item.id.toString().includes(searchTerm) ||
            item.phone.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.broadcast_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.data.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.delivery_date.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.received_at.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.confirmed.toString().includes(searchTerm) ||
            item.canceled.toString().includes(searchTerm)
        );
    });

    // const keys = Object.keys(confirmations[0] || {});

    const handleTableChange = (state) => {
        setCurrentPage(page + 1);
    };

    const renderPagination = () => {
        if (totalPages < 2) {
            return null;
        }
    }

    const renderPageButtons = () => {
        const pageButtons = [];
        const maxButtons = 5;
        const halfMaxButtons = Math.floor(maxButtons / 2);

        let start = Math.max(1, currentPage - halfMaxButtons);
        let end = Math.min(totalPages, start + maxButtons - 1);

        if (end - start < maxButtons - 1) {
            start = Math.max(1, end - maxButtons + 1);
        }

        const renderDots = (position) => (
            <li key={position} className='page-item mx-2'>
                <span className='rounded-circle page-link px-3 py-2'>...</span>
            </li>
        );

        if (start > 1) {
            pageButtons.push(renderDots('start'));
        }

        for (let i = start; i <= end; i++) {
            pageButtons.push(
                <li key={i} className={`page-item mx-2 ${currentPage === i ? 'active' : ''}`}>
                    <button className='justify-content-center align-items-center d-flex rounded-circle page-link' onClick={() => setCurrentPage(i)} >
                        {i}
                    </button>
                </li>
            );
        }

        if (end < totalPages) {
            pageButtons.push(renderDots('end'));
        }

        return pageButtons;
    };

    return (
        <>
            <Helmet>
                <title>All Confirmations | {metTitle}</title>
                <meta name="description" content={metaDescription}/>
                <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
            </Helmet>
            <div className='my-5'>
                <div className='row justify-content-center align-items-center py-5 rounded-25'>
                    <div className='container-fluid justify-content-center'>
                        <div className='rounded-25 card bg-white border justify-content-center align-items-center'>
                            <img width={52} height={52} className='ic-card mx-auto' src={icBrodccast} />
                            <div className='row justify-content-start w-100'>
                                <div className="col-md-3 search-container order-md-1">
                                    <input
                                        className='form-control rounded-pill'
                                        type="text"
                                        placeholder="Search..."
                                        value={searchTerm}
                                        onChange={handleSearch}
                                    />
                                </div>
                                <h1 className='col-md-6 text-center title my-3 order-first order-md-2'>All Confirmations</h1>
                            </div>
                            <div className='divider my-4'></div>

                            {!loading ? <div className='w-100 justify-content-cener'>
                                {hasData ? <div className='table-responsive mt-3'>
                                    <table className='table text-center mb-0'>
                                        <thead>
                                            <tr>
                                                <th className='table-head text-capitalize' scope='col'>Broadcast Name</th>
                                                <th className='table-head text-capitalize' scope='col'>Phone</th>
                                                {/* <th className='table-head text-capitalize' scope='col'>Address</th> */}
                                                <th className='table-head text-capitalize' scope='col'>Received at</th>
                                                <th className='table-head text-capitalize' scope='col'>Delivery date</th>
                                                <th className='table-head text-capitalize' scope='col'>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody className='table-bordered'>
                                            {filteredData.map((item) => (
                                                <React.Fragment key={item.id}>

                                                    <tr role='button' onClick={() => setExpandedRow(expandedRow === item.id ? null : item.id)} key={item.id}>
                                                        <td className='px-4'>{item.broadcast_name}</td>
                                                        <td className='px-4'>{item.phone}</td>
                                                        {/* <td className='px-4 text-start'>{item.data}</td> */}
                                                        <td className='px-4'>{item.received_at}</td>
                                                        <td className='px-4'>{item.delivery_date}</td>
                                                        <td colSpan='6' className='px-4'>
                                                            <div className='d-flex justify-content-center align-items-center'>
                                                                <span className={`d-flex me-2`}>
                                                                    <img width={10} className='mx-1' src={btnCheck} alt='' srcSet='' />
                                                                    <span className='txt-green'>Confirmed</span>
                                                                </span>
                                                                <span className={`${item.classSent} d-flex ms-auto`}>
                                                                    <span className={`d-flex justify-content-center align-items-center btn-view mx-1`} href=''>
                                                                        <img src={icBtnVeiw} alt='' srcSet='' />
                                                                    </span>
                                                                    <span role='button' className={`d-flex mx-1`} onClick={() => setExpandedRow(expandedRow === item.id ? null : item.id)}>
                                                                        <img src={expandedRow != item.id ? icArrowRight : icArrowDown} alt='' />
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    {expandedRow === item.id && (
                                                        <tr className='bg-green-table p-2 text-start'>
                                                            <td className='p-3' colSpan="6">
                                                                {item.data}
                                                            </td>
                                                        </tr>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </tbody>
                                    </table>
                                </div> : <p className="text-center my-3">There is currently no information to display.</p>}
                            </div> : <p className='my-3 text-center'>Loading..</p>}
                        </div>
                        {!loading ? currentPage >= 1 ?
                            <nav aria-label='Page navigation'>
                                <ul className='pagination justify-content-center align-items-center my-5'>
                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className='mx-2 justify-content-center align-items-center d-flex rounded-circle page-link'
                                            onClick={handlePrevPage}
                                            disabled={currentPage === 1}
                                        >
                                            <img src={icPreview} alt='prevhandleTableChangeiew' />
                                        </button>
                                    </li>
                                    {renderPageButtons()}
                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                        <button
                                            className='justify-content-center align-items-center d-flex rounded-circle page-link'
                                            onClick={handleNextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            <img src={icNext} alt='next' />
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                            : <></> : <></>}
                    </div>
                </div>
            </div>
        </>
    )
}


export default AllConfirmations;